import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    configurationTempData: {},
  },
  mutations: {
    saveConfigurationTempData: function (state, data) {
      state.configurationTempData = data;
    },
  },
});
